/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import { observer } from "mobx-react";
import 'swiper/css';
import 'swiper/css/pagination';
import Image from 'next/image';
import studioStore from '@/stores/studioStore';

const HeroSection = observer(({
  slides,
}) => {
  return (
    <div className="hero-section max-w-[1920px] mx-auto">
      <Swiper
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        loop
        pagination={{
          clickable: true,
          renderBullet: (index, className) => {
            // Customize each bullet with inline style
            return `<span className="${className}" style="background-color: ${studioStore.settings.colors.primary_color}; width: 12px; height: 12px; margin: 0 6px;"></span>`;
          },
        }}
        modules={[Pagination, Autoplay]}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <a href={slide.url} rel="noopener noreferrer">
              <Image src={slide.image.url} alt={slide.image.alt || `Slide ${index + 1}`} width={slide.image.width} height={slide.image.height} priority sizes={`(max-width: 768px) 100vw, (max-width: 1200px) 50vw, ${slide.image.width}px`} quality={80} />
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
});

export default HeroSection;